import { computed } from 'vue';

const getEngagementBarsValue = (engagementScore, state) => {
  if (state === 'lost_pulse' || state === 'never_generated' || state === 'generating') {
    return 0;
  }

  if (engagementScore === undefined || engagementScore === null) {
    return 0;
  }

  const score = engagementScore;
  if (score === 0) return 0;
  if (score > 0 && score <= 25) return 1;
  if (score > 25 && score <= 50) return 2;
  if (score > 50 && score <= 75) return 3;
  return 4;
};

const getSentimentFaceValue = (sentimentScore, state) => {
  // Report disabled or never generated - use question mark
  if (state === 'lost_pulse' || state === 'never_generated' || state === 'generating') {
    return 'question';
  }

  // No sentiment data (no messages or error for that week) - use flat face
  if (sentimentScore === null || sentimentScore === undefined || !Number.isFinite(sentimentScore)) {
    return 'flat';
  }

  const score = Math.max(0, Math.min(100, sentimentScore));
  // Evenly distributed: 5 faces, range of 20 each (0-19, 20-39, 40-59, 60-79, 80-100)
  if (score < 20) return 1;
  if (score < 40) return 2;
  if (score < 60) return 3;
  if (score < 80) return 4;
  return 5;
};

const useEngagementReportIcons = (data) => {
  const engagementBarsValue = computed(() => {
    const dataValue = data.value ?? data;
    const score = dataValue?.engagementScore;
    const state = dataValue?.state;
    return getEngagementBarsValue(score, state);
  });

  const engagementBarsPath = computed(() => `nucleo/meter-bars-${engagementBarsValue.value}`);

  const sentimentFaceValue = computed(() => {
    const dataValue = data.value ?? data;
    const score = dataValue?.sentimentScore;
    const state = dataValue?.state;
    return getSentimentFaceValue(score, state);
  });

  const sentimentFacePath = computed(() => `nucleo/sentiment-face-${sentimentFaceValue.value}`);

  return {
    engagementBarsValue,
    engagementBarsPath,
    sentimentFaceValue,
    sentimentFacePath,
  };
};

export default useEngagementReportIcons;

